import { Grid, Box, Image } from '@chakra-ui/react';
import React from 'react';
import ReactPlayer from 'react-player';

export default function ProductPhotos({ productMedia, productTitle, handleZoom }) {
  return (
    <Box flex={5}>
      {productMedia && productMedia.length > 0 ? (
        <Grid templateColumns={`repeat(2, 1fr)`} templateRows={`repeat(${productMedia?.length / 2}, 1fr)`} gap={2}>
          {productMedia?.map(({ url, type }, index) =>
            type === 'image' ? (
              <Box key={`ProductPhotos-${index}`}>
                <Image
                  width={'100%'}
                  height={'auto'}
                  src={url}
                  key={url}
                  alt={productTitle}
                  onClick={() => {
                    handleZoom(index);
                  }}
                  cursor={'pointer'}
                />
              </Box>
            ) : (
              <Box
                paddingBottom={'99% !important'}
                style={{ position: 'relative', width: '100%', height: 0 }}
                position={'relative'}
                className="video-product"
              >
                <ReactPlayer
                  loop={true}
                  playing={true}
                  controls={false}
                  volume={0}
                  width="100%"
                  height="100%"
                  style={{ position: 'absolute', top: 0, left: 0 }}
                  playsinline={true}
                  url={url}
                  key={url}
                />
              </Box>
            )
          )}
        </Grid>
      ) : null}

      {productMedia && productMedia.length === 0 ? (
        <Box width={'100%'}>
          <Image
            w={250}
            h={250}
            alt={'No photo available'}
            maxW="100%"
            maxH={'100%'}
            src={'/assets/no-photo.png'}
            m={'30px auto'}
          />
        </Box>
      ) : null}
    </Box>
  );
}
